module.exports = __webpack_public_path__ + "static/media/bf110.4f2a11dc.jpg";